const makerjs = require('makerjs')

import { layerNames } from '@/js/cad/CadLayerNaming.js'

export default class Shelf {
  constructor(spiceRack, materialThickness, shelfInfo) {
    this.models = {}

    this.spiceRack = spiceRack
    this.materialThickness = materialThickness
    this.shelfInfo = shelfInfo

    this.tSlotDepth = shelfInfo?.tSlotDepth
    this.widthLoss = shelfInfo?.widthLoss
    this.shelfSetback = shelfInfo?.shelfSetback

    this.notchSetback = shelfInfo?.notchSetback
    this.notchSquareDepth = shelfInfo?.notchSquareDepth
    this.notchCutDepth = shelfInfo?.notchCutDepth
    this.notchWidth = shelfInfo?.notchWidth

    this.backRebateSetback = shelfInfo?.backRebateSetback

    //CALCS
    this.shelfWidth = spiceRack.w - (materialThickness - this.tSlotDepth) * 2
    this.shelfDepth = spiceRack.d - this.shelfSetback

    for (let i = 0; i < spiceRack.shelves; i++) {
      this.createShelf(i + 1)
    }
  }

  createShelf(copy) {
    let shelf = (this.models['shelf' + copy] = { models: {} })

    shelf.models.outline = {
      layer: layerNames.cutout.label,
      paths: {
        line1: {
          type: 'line',
          origin: [0, 0],
          end: [this.shelfWidth, 0]
        },
        line2: {
          type: 'line',
          origin: [this.shelfWidth, 0],
          end: [this.shelfWidth - this.widthLoss, this.shelfDepth - this.notchSetback]
        },
        line3: {
          type: 'line',
          origin: [this.shelfWidth - this.widthLoss, this.shelfDepth - this.notchSetback],
          end: [this.shelfWidth - this.tSlotDepth, this.shelfDepth - this.notchSetback]
        },
        line4: {
          type: 'line',
          origin: [this.shelfWidth - this.tSlotDepth, this.shelfDepth - this.notchSetback],
          end: [this.shelfWidth - this.tSlotDepth, this.shelfDepth]
        },
        line5: {
          type: 'line',
          origin: [this.shelfWidth - this.tSlotDepth, this.shelfDepth],
          end: [this.tSlotDepth, this.shelfDepth]
        },
        line6: {
          type: 'line',
          origin: [this.tSlotDepth, this.shelfDepth],
          end: [this.tSlotDepth, this.shelfDepth - this.notchSetback]
        },
        line7: {
          type: 'line',
          origin: [this.tSlotDepth, this.shelfDepth - this.notchSetback],
          end: [this.widthLoss, this.shelfDepth - this.notchSetback]
        },
        line8: {
          type: 'line',
          origin: [this.widthLoss, this.shelfDepth - this.notchSetback],
          end: [0, 0]
        }
      }
    }
    shelf.models.outline.layer = layerNames.cutout.label

    // create shelf notch (offset by shelfWidth to align with outline)
    shelf.models.shelfNotchA = new makerjs.models.Rectangle(this.notchWidth, this.notchSquareDepth)
    makerjs.model.move(shelf.models.shelfNotchA, [
      this.shelfWidth - this.tSlotDepth,
      this.shelfDepth - this.notchSetback - this.notchCutDepth
    ])

    shelf.models.shelfNotchB = new makerjs.models.Rectangle(this.notchWidth, this.notchSquareDepth)
    makerjs.model.move(shelf.models.shelfNotchB, [
      this.tSlotDepth - this.notchWidth,
      this.shelfDepth - this.notchSetback - this.notchCutDepth
    ])

    shelf.models.shelfNotchA.layer = layerNames.finNotch.label
    shelf.models.shelfNotchB.layer = layerNames.finNotch.label

    // create shelf back rebate
    shelf.models.shelfBackRebate = {
      layer: layerNames.spiceRackShelfBackRebate.label,
      paths: {
        rebateLine: {
          type: 'line',
          origin: [-5, this.backRebateSetback],
          end: [this.shelfWidth + 5, this.backRebateSetback]
        }
      }
    }

    // Position shelves one ontop of the other
    makerjs.model.move(shelf, [0, (this.shelfDepth + 13) * (copy - 1)])
  }
}
